/**
 * Unregistered pairing rows are persisted under LUCIMARK:TENANT:REGISTRATION. `webOta` carries a JWT and
 * version metadata that goes stale after deploys and inflates localStorage; the player should use
 * GET /registration and the WebSocket handshake as sources of truth instead.
 *
 * @see AuthenticationService.setRegistration (pairing branch)
 * @see getPlayerRegistrationAndRegistrationStatus in usePlayer (always refreshes when tenantId is null)
 */
export function stripWebOtaForPairingPersistence<T extends Record<string, unknown>>(registration: T): T {
  if (!('webOta' in registration)) {
    return registration
  }
  const { webOta: _omit, ...rest } = registration
  return rest as T
}
